import { computed } from "vue";
import useCreateComponentConfig from "../../../composables/useCreateComponentConfig.js";
import { EProgressStepsElements } from "../types.js";
import { SIZES } from "@/ui/ts/types/Sizes";
export function useProgressStepsConfig(props, currentOrientation) {
  const { rootClasses } = useRootConfig(currentOrientation);
  const { itemClasses } = useItemConfig(props, currentOrientation);
  const { stepBlockClasses } = useStepBlockConfig(props, currentOrientation);
  const { textBlockClasses } = useTextBlockConfig(props, currentOrientation);
  const { titleClasses } = useTitleConfig(props, currentOrientation);
  const { descriptionClasses } = useDescriptionConfig(props);
  return {
    root: rootClasses,
    item: itemClasses,
    stepBlock: stepBlockClasses,
    textBlock: textBlockClasses,
    title: titleClasses,
    description: descriptionClasses
  };
}
function useRootConfig(currentOrientation) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.ROOT,
    /* tw */
    currentOrientation === "vertical" ? "flex-col" : ""
  );
  const rootClasses = computed(() => getClasses(EProgressStepsElements.ROOT));
  return {
    rootClasses: rootClasses.value
  };
}
function useItemConfig(props, currentOrientation) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.ITEM,
    /* tw */
    `flex w-full ${currentOrientation === "horizontal" ? "flex-col" : ""}`
  );
  addSize(
    EProgressStepsElements.ITEM,
    SIZES.SMALL,
    /* tw */
    `gap-y-2xs gap-x-base ${currentOrientation === "horizontal" ? "items-center" : ""}`
  );
  addSize(
    EProgressStepsElements.ITEM,
    SIZES.MEDIUM,
    /* tw */
    `gap-base`
  );
  const itemClasses = computed(() => getClasses(EProgressStepsElements.ITEM, void 0, props.size));
  return {
    itemClasses: itemClasses.value
  };
}
function useStepBlockConfig(props, currentOrientation) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.STEPBLOCK,
    /* tw */
    `relative flex items-center ${currentOrientation === "vertical" ? "flex-col" : ""}`
  );
  addSize(
    EProgressStepsElements.STEPBLOCK,
    SIZES.SMALL,
    /* tw */
    currentOrientation === "horizontal" ? "w-[calc(100%-var(--size-units-6)+1px)] justify-center" : ""
  );
  const stepBlockClasses = computed(() => getClasses(EProgressStepsElements.STEPBLOCK, void 0, props.size));
  return {
    stepBlockClasses: stepBlockClasses.value
  };
}
function useTextBlockConfig(props, currentOrientation) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.TEXTBLOCK,
    /* tw */
    `gap-y-xs flex flex-col`
  );
  addSize(
    EProgressStepsElements.TEXTBLOCK,
    SIZES.SMALL,
    currentOrientation === "horizontal" ? (
      /* tw */
      "px-2xs text-center"
    ) : (
      /* tw */
      "pt-3xs pb-lg group-data-[last=true]:pb-0"
    )
  );
  addSize(
    EProgressStepsElements.TEXTBLOCK,
    SIZES.MEDIUM,
    currentOrientation === "horizontal" ? (
      /* tw */
      "pr-md"
    ) : (
      /* tw */
      "pt-xs pb-xl group-data-[last=true]:pb-0"
    )
  );
  const textBlockClasses = computed(() => getClasses(EProgressStepsElements.TEXTBLOCK, void 0, props.size));
  return {
    textBlockClasses: textBlockClasses.value
  };
}
function useTitleConfig(props, currentOrientation) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.TITLE,
    /* tw */
    "text-neutral-primary font-default line-clamp-3 font-semibold"
  );
  addSize(
    EProgressStepsElements.TITLE,
    SIZES.SMALL,
    currentOrientation === "horizontal" ? (
      /* tw */
      "label-xs"
    ) : (
      /* tw */
      "label-md"
    )
  );
  addSize(
    EProgressStepsElements.TITLE,
    SIZES.MEDIUM,
    /* tw */
    "label-lg"
  );
  const titleClasses = computed(() => getClasses(EProgressStepsElements.TITLE, void 0, props.size));
  return {
    titleClasses: titleClasses.value
  };
}
function useDescriptionConfig(props) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    EProgressStepsElements.DESCRIPTION,
    /* tw */
    "font-default text-neutral-primary font-medium"
  );
  addSize(
    EProgressStepsElements.DESCRIPTION,
    SIZES.SMALL,
    /* tw */
    `paragraph-sm`
  );
  addSize(
    EProgressStepsElements.DESCRIPTION,
    SIZES.MEDIUM,
    /* tw */
    `paragraph-md`
  );
  const descriptionClasses = computed(() => getClasses(EProgressStepsElements.DESCRIPTION, void 0, props.size));
  return {
    descriptionClasses: descriptionClasses.value
  };
}
